import { getParamByIdsOptions, getParamByIdsQueryKey } from "@/client/@tanstack/react-query.gen"
import { readCache } from "@/store/action"

const keys = [
  'rule',
  'errors',
  'start_end'
] as const;

type ParamKey = typeof keys[number];
type Params = Record<ParamKey, any>;

//Params
export const getParams = () => {
  return readCache<any, Params>(getParamByIdsQueryKey({
    path: {
      ids: keys as any,
    }
  }))
}
export const useParamsOptions = () => {
  return getParamByIdsOptions({
    path: {
      ids: keys as any,
    }
  })
}
